import { NodeViewWrapper } from '@tiptap/react';
import React, { useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { getPresetId } from '../../../components/utils/tiptap';
import DaDeviation from './DaDeviation';
import { EXTENSION_TYPE_NAME } from '../constants';
import viewerStyles from '../Viewer/Viewer.scss';
const DeviationNodeView = (props)=>{
    const Renderer = props.editor.extensionStorage['da-ext-renderers'].deviation;
    const { editor, updateAttributes, extension, node } = props;
    const { options } = extension;
    const attrs = node.attrs;
    const editorDomRef = useRef(undefined);
    useEffect(()=>{
        editorDomRef.current = editor.view.dom;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onResizeEnd = useCallback((nextWidth)=>{
        updateAttributes({
            width: nextWidth
        });
    }, [
        updateAttributes
    ]);
    const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;
    var _attrs_link;
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        key: nodeKey,
        "data-drag-handle": "true",
        "data-da-type": EXTENSION_TYPE_NAME,
        className: cn('draggable-atomic', viewerStyles['deviation-container'], viewerStyles[attrs.alignment], options.smallMedia && viewerStyles['small-media'], viewerStyles[`preset-${getPresetId(editor)}`])
    }, /*#__PURE__*/ React.createElement(DaDeviation, {
        deviation: attrs.deviation,
        link: (_attrs_link = attrs.link) !== null && _attrs_link !== void 0 ? _attrs_link : undefined,
        Renderer: Renderer,
        onResizeEnd: onResizeEnd,
        extOptions: options,
        alignment: attrs.alignment,
        attrWidth: attrs.width,
        defaultWidth: options.defaultWidth,
        editorDomRef: editorDomRef
    }));
};
DeviationNodeView.displayName = 'DeviationNodeView';
export default DeviationNodeView;

//# sourceMappingURL=DeviationNodeView.js.map